import { BlackList } from '@/modules/BlackList';
import Repository from './client/TbsJsonAxiosClient';

const resource = '';

export type BlacklistMap = Map<string, BlackList>;

export const useBlacklistRepository = () => {
  /**
   * ブラックリスト一覧をMapにして取得する（検索しやすいようにする為）
   */
  const getMap = async (): Promise<Map<string, BlackList>> => {
    const { data } = await Repository.get(`${resource}/search_blacklist.json`).catch((e) => {
      throw e;
    });

    const result: BlacklistMap = new Map();

    data.forEach((item: any) => {
      const _item: BlackList = {
        id: item.id,
        url: item.url,
        displayType: <'0' | '1'>item.displayKind,
        contentType: <'0' | '1' | '2'>item.targetKind,
      };
      result.set(item.id, _item);
    });

    return result;
  };

  return { getMap };
};

export type BlacklistRepository = ReturnType<typeof useBlacklistRepository>;
